import { Button, Modal, addToast, Icon } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import useTexts from '../hooks/useTexts';
import { getFileUploadFailure } from '../api';
import { downloadFromBlob } from '../../../utils/blob';
import dayjs from 'dayjs';

export interface UploadFailureModalRef {
  openModal: () => void;
  closeModal: () => void;
}

interface Props {
  fileUploadFailureId: string;
}

const UploadFailureModal = forwardRef<UploadFailureModalRef, Props>(
  ({ fileUploadFailureId }, ref) => {
    const [modal, setModal] = useState(false);
    const texts = useTexts();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleDownload = async () => {
      setIsLoading(true);
      const res = await getFileUploadFailure(fileUploadFailureId);

      if (res.error) {
        addToast({
          icon: 'error',
          color: 'danger',
          text: texts.uploadFailureModal.error,
        });
      } else {
        const date = dayjs().format('DD/MM/YYYY');
        const blob = new Blob([res.data], { type: 'vnd.ms-excel' });
        const fileName = `Planilla_carga_masiva_con_errores_${date}.xlsx`;
        downloadFromBlob(blob, fileName);
      }
      setIsLoading(false);
      setModal(false);
    };

    useImperativeHandle(ref, () => ({
      openModal() {
        setModal(true);
      },
      closeModal() {
        setModal(false);
      },
    }));

    return (
      <Modal isOpen={modal} toggle={() => setModal(!modal)} size="md">
        <Container fluid>
          <Row className="justify-content-center mt-4">
            <Col xs="auto">
              <Icon name="warning" size="60" />
            </Col>
          </Row>
          <p className="text-dark fs-22 mt-3 mb-4 text-center">
            {texts.uploadFailureModal.title}
          </p>
          <p className="text-dark fs-16 mt-3 mb-4 text-center">
            {texts.uploadFailureModal.description}
          </p>
          <Row>
            <Col className="text-center mt-4">
              <Button
                onClick={() => setModal(false)}
                text={texts.uploadFailureModal.ok}
                style={{ width: '350px' }}
              />
            </Col>
          </Row>

          <Row>
            <Col className="text-center mt-3">
              <Button
                outlined={true}
                onClick={handleDownload}
                text={texts.uploadFailureModal.download}
                loading={isLoading}
                disabled={isLoading}
                style={{ width: '350px' }}
                icon="download"
              />
            </Col>
          </Row>
        </Container>
      </Modal>
    );
  },
);

export default UploadFailureModal;
